var classes = {"videoSliderContainer":"vVK2Z","videoSliderGrid":"bZLCY","videoSliderContentContainer":"Tvvk6","videoCarouselSliderGrid":"H0fGv"};

export { classes as default };
